// Native GET navigation keeps the URL, filter links and SEO metadata in sync.
export default function initNewsCatalogFilters(form) {
  const search = form.querySelector('[name="search"]');
  const date = form.querySelector('[name="date"]');
  const clearDate = form.querySelector('.js-article-list__clear-date');
  const wrapper = form.querySelector('.js-article-list__input-block');
  let timeout;
  let previousDate = date.value;

  // A server-rendered date survives pagination/reload, before the calendar opens.
  if (clearDate) clearDate.style.display = date.value ? 'block' : 'none';

  const submit = () => {
    clearTimeout(timeout);
    if (date._flatpickr?.isOpen) {
      timeout = setTimeout(submit, 2000);
      return;
    }
    form.requestSubmit();
  };

  form.addEventListener('submit', () => clearTimeout(timeout));
  search.addEventListener('input', () => {
    clearTimeout(timeout);
    timeout = setTimeout(submit, 2000);
  });
  search.addEventListener('focus', () => wrapper.classList.add('article-list__input-block--focused'));
  search.addEventListener('blur', () => wrapper.classList.remove('article-list__input-block--focused'));
  date.addEventListener('change', () => {
    // Flatpickr changes the input after each click; wait until the calendar closes.
    if (date._flatpickr?.isOpen || date.value === previousDate) return;
    previousDate = date.value;
    submit();
  });
}
